module.exports = __webpack_public_path__ + "images/external_images/svg/mockups/phone-mockup-4.svg";